export default __webpack_public_path__ + "static/media/goopter-promobot-smart-delivery.35b7c3e9.png";